// extracted by mini-css-extract-plugin
module.exports = {"container":"e_7qb","grayStyle":"e_8qb"};